import { Auth } from 'aws-amplify'
import router from '@/router'

export default {
    namespaced: true,

    state: {
        currentAuthView: 'SignIn',
        signedIn: false,
        authDialog: false,
        username: null,
        showConfirmUser: false,
    },

    actions: {
        currentAuthView({commit},value) {
            commit('currentAuthView',value);
        },
        signIn({commit,dispatch},value) {
            commit('updateUsername',value);
            commit('signIn');
            dispatch('data/loadSignInData',value,{root:true});
        },
        signOut({commit,dispatch},empty) {
            commit('signOut');
            commit('updateUsername',null);
            commit('authDialog',false);  
            dispatch('data/dataSignOut',empty,{root:true});
        },
        authDialog({commit},value) {
            commit('authDialog',value);
        },
        showConfirmUser({commit},value) {
            commit('showConfirmUser',value);
        },
        newUserCreated({commit}) {
            commit('showConfirmUser',true);
            commit('currentAuthView','SignIn');
        },
        updateUsername({commit},value) {
            commit('updateUsername',value);
        }
    },

    mutations: {
        currentAuthView(state,value) {
            state.currentAuthView = value;
        },
        signIn(state) {
            state.signedIn = true;
        },
        signOut(state) {
            
            if (state.signedIn == true) {
                Auth.signOut({ global: true })
                .then(data => {
                    console.log('signout success:',data);
                    router.push('/');
                })
                .catch(err => {
                    console.log('signout error:',err);
                });
                
                state.signedIn = false;
            }

        },
        authDialog(state,value) {
            state.authDialog = value;
        },
        showConfirmUser(state,value) {
            state.showConfirmUser = value;
        },
        updateUsername(state,value) {
            state.username = value;
        },
    },

    getters: {
        currentAuthView(state){
            return state.currentAuthView;
        },
        signedIn(state){
            return state.signedIn;
        },
        authDialog(state){
            return state.authDialog;
        },
        showConfirmUser(state){
            return state.showConfirmUser;
        },
        username(state){
            return state.username;
        },
    }

}
